export default {
  mobile: 'only screen and (min-width: 481px)',
  small: 'only screen and (min-width: 576px)',
  medium: 'only screen and (min-width: 768px)',
  large: 'only screen and (min-width: 993px)'
}
